import LandingMenu from 'components/Menu';
import { Outlet } from 'react-router-dom';
import iWillLogoWhite from '../assets/iWillLogoWhite.png';
import { Icon, Icons } from 'components/Icon';
import Button from 'components/Form/Button';

export default function LandpageLayout() {
  return (
    <main className="flex min-h-screen flex-col bg-white">
      <LandingMenu />
      <div className="mx-auto flex w-full grow flex-col">
        <Outlet />
      </div>
      <footer className="h-full bg-[#121638] pb-20">
        <div className="mx-auto flex w-full flex-col items-center py-10 md:px-36">
          <img src={iWillLogoWhite} className="h-10 w-32" />
          <div className="my-10 flex flex-row gap-5">
            <a
              href="https://www.facebook.com/share/8dvQ1sbmHdWu3WA6/?mibextid=LQQJ4d"
              target="_blank"
              rel="noreferrer"
            >
              <Icon name={Icons.Facebook} />
            </a>
            <a
              href="https://x.com/leadway_capital?s=21&t=gUxjb1Ti2_gNjZuyEX17rw"
              target="_blank"
              rel="noreferrer"
            >
              <Icon name={Icons.Twitter} />
            </a>
            <a
              href="https://www.linkedin.com/company/leadway-group/posts/?feedView=all"
              target="_blank"
              rel="noreferrer"
            >
              <Icon name={Icons.LinkedIn} />
            </a>
            <a
              href="https://www.instagram.com/leadway_capital/profilecard/?igsh=cGdlc3Fva3p6b25o"
              target="_blank"
              rel="noreferrer"
            >
              <Icon name={Icons.Instagram} />
            </a>
          </div>
          <div className="relative w-[75%]">
            <input
              type="email"
              placeholder="Enter your email and never miss an update"
              className="block w-full rounded-2xl bg-gray-200 px-4 py-6 text-lg placeholder:text-gray-500 focus:border-white focus:outline-none focus:ring"
            />
            <Button
              variant="primary"
              size="md"
              className="absolute right-1 top-0 mx-5 mr-1 mt-2 h-[4rem] w-[10rem] rounded-[15px]"
              label="Subscribe"
            ></Button>
          </div>
        </div>
      </footer>
    </main>
  );
}
